<app-nav-admin></app-nav-admin>

<div class="container">
    <router-outlet></router-outlet>
</div>
